import React from 'react'
import './Common_Product_Card.css'
import { useNavigate } from 'react-router-dom'

const Common_Product_Card = (props) => {

    const navigate = useNavigate()

    return (
        <section className='Common_Product_Card' onClick={() => {navigate(props?.goto)}}>
            <div  className={`outer_colored_card ${props?.theme_colour}`}>
                <div className='img_holder'>
                    <img src={process.env.PUBLIC_URL + props?.prodImg} className='prod_img' />
                </div>

                <div className='text_holder'>
                    <p className='prod_name'>{props?.prodName}</p>
                </div>
            </div>
        </section>
    )
}

export default Common_Product_Card
